var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57495 14.5999L2.1416 9.1666C1.5 8.5249 1.5 7.4749 2.1416 6.83324L7.57495 1.3999",
    stroke: "url(#paint0_linear_1_3)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 5.79577,
    y1: 3.75621,
    x2: 0.066901,
    y2: 8.5016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftColored);
export default __webpack_public_path__ + "static/media/arrow-left-colored.f7d13f677334beb43fd56269dd210f62.svg";
export { ForwardRef as ReactComponent };